import { post, put } from '../Services/http';
import {
  pushEcommerce,
  dataLayerAddToCart,
} from '../Services/Gtm.service';
import { QuickOrderProduct } from '../Reducers/QuickOrder.reducer';

export const addMultiple = async (products: QuickOrderProduct[]) => {
  if (
    products.filter(
      (p) =>
        !p.totalAmount.total ||
        isNaN(p.totalAmount.total) ||
        p.totalAmount.total <= 0
    ).length > 0
  ) {
    throw 'Invalid quantity';
  }

  const response = await post(
    '/api/cart/addMultiple',
    products.map((product) => {
      return {
        articleNumber: product.id,
        quantity: product.totalAmount.total,
        note: product.note,
      };
    })
  );
  return response.json();
};
